<template>
	<div style="display: flex; flex: 1; width: 100%; position: relative; overflow: hidden;">
		<div id="outer">
			<div style="flex: 1; width: 100%; margin: 0;">
				<p style="font-size: 60px; overflow: hidden; text-overflow: ellipsis;">
					{{ room_name }}
				</p>
				<button
					@click="start_game"
					style="width: 150px; height: 60px; margin-left: auto; margin-right: auto;"
				> Start Game </button>
				<p style="font-size: 25px">Players:</p>
				<div id="player-list" style="margin: 0; width: 100%;">
					<p
						v-for="(player, index) in player_names"
						:key="index"
						style="margin: 0; width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
					>
						{{ player }}
					</p>
				</div>
			</div>
			<div>
				<p style="font-size: 30px;">House Rules</p>
				<HouseRule :rule="'draw_until_play'">Draw cards until playable</HouseRule>
				<HouseRule :rule="'no_end_on_wild'">No ending on a wild card</HouseRule>
				<HouseRule :rule="'stackable_plus'">Stackable +2s and +4s</HouseRule>
				<HouseRule :rule="'seven_zero'">7-0</HouseRule>
				<button
					@click="leave_room"
					style="height: 40px; width: 100%; margin: 0;"
				> Leave Room </button>
			</div>
		</div>
		<div id="overlay" style="">
			<transition name="covering_panel">
				<div class="covering_panel" v-if="results != null" @click="results = null"/>
			</transition>
			<transition name="results">
				<div class="results" v-if="results != null">
					<div style="flex: 1;">
						<p style="font-size: 40px; margin-bottom: 10px; overflow: hidden; text-overflow: ellipsis;">
							Results
						</p>
						<p v-if="results.winner_index == results.your_index">
							You won!
						</p>
						<p v-else>
							You lost.
						</p>
						<br>
						<p style="font-size: 30px; margin-bottom: 10px; overflow: hidden; text-overflow: ellipsis;">
							Scores
						</p>
						<div v-for="(d, i) in results.scores" :key="i">
							<p
								:style="{ 'font-weight': i == results.winner_index ? 'bold' : 'normal' }"
							>
							{{ d[0] + (i == results.your_index ? " (You)" : "") }}: {{ d[1] }}
							</p>
						</div>
					</div>
					<button @click="results = null">OK</button>
				</div>
			</transition>
		</div>
	</div>
</template>

<style scoped>
#outer {
	margin: 10px;
	padding: 4px;
	position: relative;
	flex: 1;
	border-radius: 10px;
	box-shadow: 0px 0px 10px var(--shadow_color);
	width: calc(100% - 2 * 10px);
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	text-align: center;
	align-content: center;
}

#outer * {
	font-size: 20px;
	margin: 4px 10px 4px 10px;
}

#overlay {
	width: 100%;
	height: 100%;
	position: absolute;
	display: flex;
	justify-content: center;
	align-items: center;
	pointer-events: none;
}
#overlay * {
	pointer-events: auto;
}

.results-enter-active, .results-leave-active, .results {
	transition: all 0.3s ease;
	width: 50%;
	min-height: 50%;
	display: flex;
	flex-direction: column;
	text-align: center;
	align-content: center;
	padding: 4px;
	border-radius: 10px;
	box-shadow: 0px 0px 10px var(--shadow_color);
	background-color: var(--bg_color);
	z-index: 1;
}
.results-enter, .results-leave-to {
	transform: scale(0.0);
}

.covering_panel-active, .covering_panel-leave-active, .covering_panel-enter-to, .covering_panel {
	transition: opacity 0.3s ease;
	position: absolute;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.6);
}
.covering_panel-enter, .covering_panel-leave-to {
	opacity: 0;
}

.results * {
	font-size: 20px;
	margin: 4px 10px 4px 10px;
}
</style>

<script lang="ts">
import Vue from 'vue'

import HouseRule from "@/components/HouseRule.vue";

export default Vue.extend({
	components: {
		HouseRule
	},
	created() {
		this.$store.state.connection.addEventListener("message", this.on_message);
	},
	beforeDestroy() {
		this.$store.state.connection.removeEventListener("message", this.on_message);
	},
	data() {
		return {
			results: null
		}
	},
	methods: {
		on_message(event) {
			var obj = JSON.parse(event["data"]);
			if (obj[0] == "game_ended_event") {
				let d = obj[1];
				this.results = d;
			}
		},
		leave_room() {
			var obj = [
				"leave_room",
				{}
			];
			this.$store.state.connection.send(JSON.stringify(obj));
		},
		start_game() {
			var obj = [
				"start_game",
				{}
			];
			this.$store.state.connection.send(JSON.stringify(obj));
		}
	},
	computed: {
		room_name () {
			var data = this.$store.state.game_data;
			if (data == null || data.type != "Waiting") return "";
			return data.room_name;
		},
		player_names () {
			var data = this.$store.state.game_data;
			if (data == null || data.type != "Waiting") return [];
			return data.player_names;
		}
	}
})
</script>
